import { type ReactNode, useMemo } from 'react';
import { FOUNDERS_TOTAL } from '../founders-config';
import { FounderSlot } from './founder-slot';

// Vertical scroll-snap grid. `snap-y snap-mandatory` makes the
// browser magnet each row to the viewport top as the user scrolls;
// combined with `snap-start` on every slot card. Cards use
// `content-visibility: auto` (see founder-slot.tsx) so rendering
// 3333 DOM nodes stays cheap.
const GRID =
  'grid snap-y snap-mandatory grid-cols-2 gap-md sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5';

export function FoundersGrid(): ReactNode {
  const slots = useMemo(
    () => Array.from({ length: FOUNDERS_TOTAL }, (_, i) => i + 1),
    []
  );
  return (
    <div className={GRID}>
      {slots.map((n) => (
        <FounderSlot key={n} n={n} />
      ))}
    </div>
  );
}
